import React, { Dispatch, SetStateAction } from 'react'
import styles from '../AppointmentFullCalendar/AppointmentFullCalendar.module.css'
import iconClose from '../../../images/icon-close.svg';
import { AnyIfEmpty } from 'react-redux';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';

interface props {
    setOpen: (active: boolean) => void;
    locationId: string;
    setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
    calendarInfo: AnyIfEmpty<object>;
}

const VendorAppointmentPopup = ({ setOpen, locationId, setShowDeleteModal, calendarInfo }: props) => {
    return (
        <div className={`${styles.eventInfo} event-info`}>
            <div className={styles.eventHeader}>
                <div className={styles.titleWrap}>
                    <h2>Vendor Appointment</h2>
                    <div role="button" className={styles.closeIcon} onClick={() => setOpen(false)}>
                        <img src={iconClose} alt="Close" className={styles.iconRemove} />
                    </div>
                </div>
            </div>
            <div className={`${styles.eventBody} VendorAppointmentPopupBody`}>
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Vendor Name</label>
                    <p className={styles.eventDesc}>{calendarInfo?.vendorName}</p>
                </div>
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Vendor Email</label>
                    <p className={styles.eventDesc}>{calendarInfo?.vendorEmail ? calendarInfo?.vendorEmail : "-"}</p>
                </div>
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Contact No.</label>
                    <div className={`${styles.eventDesc} eventDesc`}>
                        {calendarInfo.vendorPhone ? <PhoneInput
                            value={`+${calendarInfo.vendorPhone}`}
                            disabled
                        /> : '-'}
                    </div>
                </div>
                {/* <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Property Name</label>
                    <p className={styles.eventDesc}>ITC</p>
                </div> */}
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Start Date-Time</label>
                    <p className={styles.eventDesc}>
                        {moment(calendarInfo.startDate).utc().locale('en').format('MM-DD-YYYY')} {' '}
                        {moment(calendarInfo.startTime, 'hh:mm A').format('hh:mm A')}
                    </p>
                </div>
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>End Date-Time</label>
                    <p className={styles.eventDesc}>
                        {moment(calendarInfo.endDate).utc().locale('en').format('MM-DD-YYYY')} {' '}
                        {moment(calendarInfo.endTime, 'hh:mm A').format('hh:mm A')}
                    </p>
                </div>
                <div className={styles.eventData1}>
                    <label className={styles.eventTitle}>Locker Number</label>
                    <p className={styles.eventDesc}>
                        {calendarInfo?.lockerNumber || "-"}
                    </p>
                </div>
            </div>
            <div className={styles.getMoreDetails}>
                <p onClick={() => setShowDeleteModal(true)}>Delete this Appointment</p>
            </div>
        </div>

    )
}

export default VendorAppointmentPopup
